export const SORT_BY_PRICE_NAME = 'SORT_BY_PRICE'
export const SORT_BY_INPUT_NAME = 'sortBy'
export const SORT_BY_INPUT_LABEL = 'Sort by'
export const SORT_OPTION_NAME_QUERY = 'sortOption'
export const SORT_BY_PRICE_LOW_TO_HIGH = 'lowToHigh'
